import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import './PaymentMethodsPage.css';

const PaymentMethodsPage = () => {
  const [savedMethods, setSavedMethods] = useState([
    {
      id: 1,
      type: 'card',
      cardType: 'Verve',
      last4: '3829',
      label: 'Verve Card',
      isDefault: true,
      icon: '💳'
    },
    {
      id: 2,
      type: 'card',
      cardType: 'Visa',
      last4: '5678',
      label: 'Naira Debit Card',
      isDefault: false,
      icon: '💳'
    },
    {
      id: 3,
      type: 'bank',
      bankName: 'GTBank',
      accountNumber: '1234567890',
      label: 'GTBank Account',
      isDefault: false,
      icon: '🏦'
    }
  ]);

  const [showAddForm, setShowAddForm] = useState(false);
  const [paymentMethodType, setPaymentMethodType] = useState('card');
  const [newPaymentData, setNewPaymentData] = useState({
    cardNumber: '',
    expiryDate: '',
    cvv: '',
    cardType: 'Verve',
    bankName: '',
    accountNumber: '',
    ussdBank: '',
    walletEmail: '',
    walletPhone: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewPaymentData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSetDefault = (methodId) => {
    setSavedMethods(prev => prev.map(method => ({
      ...method,
      isDefault: method.id === methodId
    })));
  };

  const handleRemoveMethod = (methodId) => {
    setSavedMethods(prev => prev.filter(method => method.id !== methodId));
  };

  const handleAddPaymentMethod = (e) => {
    e.preventDefault();
    
    let newMethod;
    if (paymentMethodType === 'card') {
      newMethod = {
        id: Date.now(),
        type: 'card',
        cardType: newPaymentData.cardType,
        last4: newPaymentData.cardNumber.slice(-4),
        label: `${newPaymentData.cardType} Card`,
        isDefault: savedMethods.length === 0,
        icon: '💳'
      };
    } else if (paymentMethodType === 'bank') {
      newMethod = {
        id: Date.now(),
        type: 'bank',
        bankName: newPaymentData.bankName,
        accountNumber: newPaymentData.accountNumber,
        label: `${newPaymentData.bankName} Account`,
        isDefault: savedMethods.length === 0,
        icon: '🏦'
      };
    } else if (paymentMethodType === 'ussd') {
      newMethod = {
        id: Date.now(),
        type: 'ussd',
        bankName: newPaymentData.ussdBank,
        ussdCode: getUSSDCode(newPaymentData.ussdBank),
        label: `${newPaymentData.ussdBank} USSD`,
        isDefault: savedMethods.length === 0,
        icon: '📱'
      };
    } else if (paymentMethodType === 'wallet') {
      newMethod = {
        id: Date.now(),
        type: 'wallet',
        walletEmail: newPaymentData.walletEmail || newPaymentData.walletPhone,
        label: 'Flutterwave Wallet',
        isDefault: savedMethods.length === 0,
        icon: '💼'
      };
    }

    if (newMethod) {
      setSavedMethods(prev => [...prev, newMethod]);
      setShowAddForm(false);
      setNewPaymentData({
        cardNumber: '',
        expiryDate: '',
        cvv: '',
        cardType: 'Verve',
        bankName: '',
        accountNumber: '',
        ussdBank: '',
        walletEmail: '',
        walletPhone: ''
      });
    }
  };

  const getUSSDCode = (bankName) => {
    const codes = {
      'GTBank': '*737#',
      'Zenith Bank': '*966#',
      'Access Bank': '*901#',
      'First Bank': '*894#',
      'UBA': '*919#',
      'Fidelity Bank': '*770#',
      'Sterling Bank': '*822#'
    };
    return codes[bankName] || '*737#';
  };

  return (
    <div className="payment-methods-page">
      <Header />
      
      {/* Page Title */}
      <section className="payment-methods-title-section">
        <div className="page-container">
          <div className="payment-methods-title-content">
            <h1 className="payment-methods-page-title">Payment Methods</h1>
            <p className="payment-methods-page-subtitle">
              Manage your saved cards and payment options.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="payment-methods-main">
        <div className="page-container">
          <div className="payment-methods-layout">
            {/* Saved Payment Methods */}
            <div className="saved-methods-section">
              <div className="methods-card">
                <div className="methods-card-header">
                  <h2 className="methods-card-title">Saved Payment Methods</h2>
                </div>
                <div className="methods-card-body">
                  {savedMethods.length > 0 ? (
                    <div className="methods-list">
                      {savedMethods.map(method => (
                        <div key={method.id} className="payment-method-card">
                          <div className="method-info">
                            <div className="method-icon-large">{method.icon}</div>
                            <div className="method-details">
                              <h3 className="method-label">{method.label}</h3>
                              {method.type === 'card' && (
                                <p className="method-number">•••• {method.last4}</p>
                              )}
                              {method.type === 'bank' && (
                                <p className="method-number">Account: {method.accountNumber.slice(-4)}</p>
                              )}
                              {method.type === 'ussd' && (
                                <p className="method-number">Code: {method.ussdCode}</p>
                              )}
                              {method.type === 'wallet' && (
                                <p className="method-number">{method.walletEmail}</p>
                              )}
                            </div>
                            {method.isDefault && (
                              <span className="default-badge">Default</span>
                            )}
                          </div>
                          <div className="method-actions">
                            {!method.isDefault && (
                              <button 
                                className="method-action-button"
                                onClick={() => handleSetDefault(method.id)}
                              >
                                Set as Default
                              </button>
                            )}
                            <button 
                              className="method-action-button remove"
                              onClick={() => handleRemoveMethod(method.id)}
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="empty-payment-state">
                      <div className="empty-payment-icon">💳</div>
                      <h3 className="empty-payment-title">No Payment Methods</h3>
                      <p className="empty-payment-text">Add a payment method to get started</p>
                      <button 
                        className="add-payment-method-button-empty"
                        onClick={() => setShowAddForm(true)}
                      >
                        Add Payment Method
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Add Payment Method Panel */}
            <div className="add-method-section">
              <div className="methods-card">
                <div className="methods-card-header">
                  <h2 className="methods-card-title">Add New Payment Method</h2>
                </div>
                <div className="methods-card-body">
                  {!showAddForm && savedMethods.length > 0 ? (
                    <button 
                      className="show-add-form-button"
                      onClick={() => setShowAddForm(true)}
                    >
                      Add Payment Method
                    </button>
                  ) : (
                    <form onSubmit={handleAddPaymentMethod} className="add-payment-form">
                      <div className="payment-type-selector">
                        <label className="payment-type-option">
                          <input
                            type="radio"
                            name="paymentType"
                            value="card"
                            checked={paymentMethodType === 'card'}
                            onChange={(e) => setPaymentMethodType(e.target.value)}
                          />
                          <span>💳 Card (Visa / MasterCard / Verve)</span>
                        </label>
                        <label className="payment-type-option">
                          <input
                            type="radio"
                            name="paymentType"
                            value="bank"
                            checked={paymentMethodType === 'bank'}
                            onChange={(e) => setPaymentMethodType(e.target.value)}
                          />
                          <span>🏦 Bank Account</span>
                        </label>
                        <label className="payment-type-option">
                          <input
                            type="radio"
                            name="paymentType"
                            value="ussd"
                            checked={paymentMethodType === 'ussd'}
                            onChange={(e) => setPaymentMethodType(e.target.value)}
                          />
                          <span>📱 USSD Payment</span>
                        </label>
                        <label className="payment-type-option">
                          <input
                            type="radio"
                            name="paymentType"
                            value="wallet"
                            checked={paymentMethodType === 'wallet'}
                            onChange={(e) => setPaymentMethodType(e.target.value)}
                          />
                          <span>💼 Wallet (Paystack / Flutterwave)</span>
                        </label>
                      </div>

                      {/* Card Form */}
                      {paymentMethodType === 'card' && (
                        <>
                          <div className="form-group">
                            <label htmlFor="cardType" className="form-label">
                              Card Type <span className="required">*</span>
                            </label>
                            <select
                              id="cardType"
                              name="cardType"
                              value={newPaymentData.cardType}
                              onChange={handleInputChange}
                              className="form-select"
                              required
                            >
                              <option value="Verve">Verve</option>
                              <option value="Visa">Visa</option>
                              <option value="MasterCard">MasterCard</option>
                            </select>
                          </div>

                          <div className="form-group">
                            <label htmlFor="cardNumber" className="form-label">
                              Card Number <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              id="cardNumber"
                              name="cardNumber"
                              value={newPaymentData.cardNumber}
                              onChange={handleInputChange}
                              placeholder="1234 5678 9012 3456"
                              className="form-input"
                              maxLength="19"
                              required
                            />
                          </div>

                          <div className="form-row">
                            <div className="form-group">
                              <label htmlFor="expiryDate" className="form-label">
                                Expiry Date <span className="required">*</span>
                              </label>
                              <input
                                type="text"
                                id="expiryDate"
                                name="expiryDate"
                                value={newPaymentData.expiryDate}
                                onChange={handleInputChange}
                                placeholder="MM/YY"
                                className="form-input"
                                maxLength="5"
                                required
                              />
                            </div>

                            <div className="form-group">
                              <label htmlFor="cvv" className="form-label">
                                CVV <span className="required">*</span>
                              </label>
                              <input
                                type="text"
                                id="cvv"
                                name="cvv"
                                value={newPaymentData.cvv}
                                onChange={handleInputChange}
                                placeholder="123"
                                className="form-input"
                                maxLength="4"
                                required
                              />
                            </div>
                          </div>
                        </>
                      )}

                      {/* Bank Account Form */}
                      {paymentMethodType === 'bank' && (
                        <>
                          <div className="form-group">
                            <label htmlFor="bankName" className="form-label">
                              Select Bank <span className="required">*</span>
                            </label>
                            <select
                              id="bankName"
                              name="bankName"
                              value={newPaymentData.bankName}
                              onChange={handleInputChange}
                              className="form-select"
                              required
                            >
                              <option value="">Select Bank</option>
                              <option value="GTBank">GTBank</option>
                              <option value="Zenith Bank">Zenith Bank</option>
                              <option value="Access Bank">Access Bank</option>
                              <option value="First Bank">First Bank</option>
                              <option value="UBA">UBA</option>
                              <option value="Fidelity Bank">Fidelity Bank</option>
                              <option value="Sterling Bank">Sterling Bank</option>
                              <option value="Union Bank">Union Bank</option>
                            </select>
                          </div>

                          <div className="form-group">
                            <label htmlFor="accountNumber" className="form-label">
                              Account Number <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              id="accountNumber"
                              name="accountNumber"
                              value={newPaymentData.accountNumber}
                              onChange={handleInputChange}
                              placeholder="Enter 10-digit account number"
                              className="form-input"
                              maxLength="10"
                              required
                            />
                          </div>
                        </>
                      )}

                      {/* USSD Form */}
                      {paymentMethodType === 'ussd' && (
                        <>
                          <div className="form-group">
                            <label htmlFor="ussdBank" className="form-label">
                              Select Bank <span className="required">*</span>
                            </label>
                            <select
                              id="ussdBank"
                              name="ussdBank"
                              value={newPaymentData.ussdBank}
                              onChange={handleInputChange}
                              className="form-select"
                              required
                            >
                              <option value="">Select Bank</option>
                              <option value="GTBank">GTBank (*737#)</option>
                              <option value="Zenith Bank">Zenith Bank (*966#)</option>
                              <option value="Access Bank">Access Bank (*901#)</option>
                              <option value="First Bank">First Bank (*894#)</option>
                              <option value="UBA">UBA (*919#)</option>
                              <option value="Fidelity Bank">Fidelity Bank (*770#)</option>
                              <option value="Sterling Bank">Sterling Bank (*822#)</option>
                            </select>
                          </div>

                          {newPaymentData.ussdBank && (
                            <div className="ussd-code-display">
                              <p className="ussd-instruction">Dial this code on your phone:</p>
                              <div className="ussd-code-box">
                                <span className="ussd-code-value">{getUSSDCode(newPaymentData.ussdBank)}</span>
                              </div>
                            </div>
                          )}
                        </>
                      )}

                      {/* Wallet Form */}
                      {paymentMethodType === 'wallet' && (
                        <>
                          <div className="form-group">
                            <label htmlFor="walletEmail" className="form-label">
                              Email or Phone <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              id="walletEmail"
                              name="walletEmail"
                              value={newPaymentData.walletEmail}
                              onChange={handleInputChange}
                              placeholder="your.email@example.com or +234 801 234 5678"
                              className="form-input"
                              required
                            />
                          </div>
                        </>
                      )}

                      <div className="form-actions">
                        <button type="submit" className="save-payment-button">
                          Save Payment Method
                        </button>
                        {showAddForm && (
                          <button 
                            type="button"
                            className="cancel-button"
                            onClick={() => {
                              setShowAddForm(false);
                              setNewPaymentData({
                                cardNumber: '',
                                expiryDate: '',
                                cvv: '',
                                cardType: 'Verve',
                                bankName: '',
                                accountNumber: '',
                                ussdBank: '',
                                walletEmail: '',
                                walletPhone: ''
                              });
                            }}
                          >
                            Cancel
                          </button>
                        )}
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Security Notice */}
          <div className="security-notice">
            <div className="security-icon">🔒</div>
            <p className="security-text">Your payment details are safely encrypted and secured.</p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PaymentMethodsPage;








